import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import { __decorate } from "tslib";
import { Vue, Options } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import store from '@/store';
import Card from '@/components/layout/Card.vue';
import { SlideDeckBackground } from '@/store/models/settings';
import { DELETE_SLIDEDECK_BACKGROUND, SET_SLIDEDECK_BACKGROUND } from '@/store/actions/platforms';
import ColorPickerBoard from '@/components/color-picker/ColorPickerBoard.vue';
var SlideDeckBackgroundItem = /*#__PURE__*/function (_Vue) {
  function SlideDeckBackgroundItem() {
    var _this;
    _classCallCheck(this, SlideDeckBackgroundItem);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, SlideDeckBackgroundItem, [].concat(args));
    _defineProperty(_this, "platform", void 0);
    _defineProperty(_this, "slideDeckBackgroud", void 0);
    _defineProperty(_this, "color", void 0);
    _defineProperty(_this, "position", void 0);
    _defineProperty(_this, "txtColor", '#F0F0F0');
    _defineProperty(_this, "logoDataUrl", '');
    _defineProperty(_this, "loadData", false);
    _defineProperty(_this, "errorMsg", '');
    _defineProperty(_this, "loading", false);
    _defineProperty(_this, "displaySlideckDeleteDialog", false);
    return _this;
  }
  _inherits(SlideDeckBackgroundItem, _Vue);
  return _createClass(SlideDeckBackgroundItem, [{
    key: "mounted",
    value: function mounted() {
      if (this.slideDeckBackgroud !== undefined) {
        this.txtColor = this.slideDeckBackgroud.color;
        this.logoDataUrl = this.platform.url + this.slideDeckBackgroud.url;
      }
    }
  }, {
    key: "onFileSelected",
    value: function onFileSelected(fileData) {
      var file = fileData.raw;
      this.loadData = true;
      var reader = new FileReader();
      reader.onloadend = this.loadLogo;
      reader.readAsDataURL(file);
    }
  }, {
    key: "loadLogo",
    value: function loadLogo(e) {
      this.logoDataUrl = e.target.result;
      this.saveSlideDeckBackground(this.txtColor);
      this.loadData = false;
    }
  }, {
    key: "saveSlideDeckBackground",
    value: function saveSlideDeckBackground(color) {
      var _this2 = this;
      this.txtColor = color;
      this.errorMsg = '';
      this.loading = true;
      var slideDeckBG = new SlideDeckBackground(this.logoDataUrl, this.txtColor, this.position);
      store.dispatch(SET_SLIDEDECK_BACKGROUND, {
        platform: this.platform,
        slideckBackground: slideDeckBG
      }).then(function () {
        _this2.errorMsg = '';
        _this2.loading = false;
      }).catch(function (err) {
        _this2.loading = false;
        _this2.errorMsg = err;
      });
    }
  }, {
    key: "deleteSlideDeckBackground",
    value: function deleteSlideDeckBackground() {
      var _this3 = this;
      this.errorMsg = '';
      this.loading = true;
      this.logoDataUrl = '';
      this.txtColor = '#F0F0F0';
      store.dispatch(DELETE_SLIDEDECK_BACKGROUND, {
        platform: this.platform,
        position: this.position
      }).catch(function (err) {
        _this3.loading = false;
        _this3.errorMsg = err;
      });
    }
  }]);
}(Vue);
__decorate([Prop()], SlideDeckBackgroundItem.prototype, "platform", void 0);
__decorate([Prop()], SlideDeckBackgroundItem.prototype, "slideDeckBackgroud", void 0);
__decorate([Prop({
  default: '#F0F0F0'
})], SlideDeckBackgroundItem.prototype, "color", void 0);
__decorate([Prop()], SlideDeckBackgroundItem.prototype, "position", void 0);
SlideDeckBackgroundItem = __decorate([Options({
  components: {
    ColorPickerBoard: ColorPickerBoard,
    Card: Card
  }
})], SlideDeckBackgroundItem);
export default SlideDeckBackgroundItem;